import React from 'react';
import { Container, Grid, Button, Typography, Box } from '@mui/material';

const buttons = [
  {
    section: 'Supplier Wise Purchases',
    items: [
      { text: '1) Specific Supplier RawMaterials Wise Purchases.', url: '/all/specificcustomerproduct' },
      { text: '2) Specific Supplier Specific RawMaterials & Date Range Wise Purchases.', url: '/all/salereportrangespecific' },
      { text: '3) Specific Supplier Date & Date Range Wise Purchases.', url: '/all/specificcustomerdaterange' },
    ],
  },
  {
    section: 'RawMaterials Wise Purchases',
    items: [
      { text: "1) All RawMaterial's Lifetime Purchases.", url: '/all/saletotal' },
      { text: '2) Specific RawMaterial Date & Date Range Wise Purchases.', url: '/all/specificproductrange' },
    ],
  },
  {
    section: 'Date Wise Purchases',
    items: [
      { text: '1) Date Range Wise Purchases.', url: '/all/salereportrange' },
      { text: '2) Date Wise Purchase Payment Due.', url: '/salespaymentdue/daterange' },
    ],
  },
];

const PurchasesReportsPage = () => (
  <Box sx={{ background: "#fff", minHeight: "100vh", py: 4 }}>
    <Container maxWidth="lg">
      {buttons.map(section => (
        <Box key={section.section} mb={4}>
          <Typography
            variant="h6"
            fontWeight="bold"
            color="success.main"
            mb={2}
            className="section-heading"
          >
            {section.section}
          </Typography>
          <Grid container spacing={2}>
            {section.items.map(item => (
              <Grid item xs={12} sm={6} md={4} key={item.text}>
                <Button
                  variant="outlined"
                  color="primary"
                  fullWidth
                  href={item.url}
                  target="_blank"
                  sx={{
                    // minHeight: 60,
                    width: '100%',                  // প্রতিটি বক্সের প্রস্থ Grid অনুযায়ী সমান
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textTransform: 'none',
                    fontWeight: 'bold',
                    fontSize: '1rem',
                    backgroundColor: '#f7fafc',
                    borderRadius: 2,
                    boxShadow: 1,
                    transition: '0.3s',
                    '&:hover': {
                      backgroundColor: '#1976d2',
                      color: '#fff',
                      borderColor: '#1976d2',
                      boxShadow: 3,
                    },
                  }}
                >
                  {item.text}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Box>
      ))}
    </Container>
  </Box>
);

export default PurchasesReportsPage;